module.exports = __webpack_public_path__ + "img/1.faa12450.png";